import { render, staticRenderFns } from "./DishesManagement.vue?vue&type=template&id=7a4007aa&scoped=true"
import script from "./DishesManagement.vue?vue&type=script&lang=ts"
export * from "./DishesManagement.vue?vue&type=script&lang=ts"
import style0 from "./DishesManagement.vue?vue&type=style&index=0&id=7a4007aa&prod&lang=css"
import style1 from "./DishesManagement.vue?vue&type=style&index=1&id=7a4007aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4007aa",
  null
  
)

export default component.exports